module.exports = __webpack_public_path__ + "img/actualCase-2.e64fd45d.jpg";